import type { ModelSubscriptionDetail } from '@/delivery-type-plugin/plugins/ModelSubscription/types/detail';

import type { ModelSubscriptionNormalizedFormState, ModelSubscriptionResourceSwitches } from './types';

/** 将详情接口响应统一解包为资源对象。 */
export function resolveDetailResource(res: ModelSubscriptionDetail | { data?: ModelSubscriptionDetail }) {
  return (res as { data?: ModelSubscriptionDetail })?.data || (res as ModelSubscriptionDetail) || {};
}

/** 创建态默认表单值。 */
export function createDefaultModelSubscriptionValues() {
  return {
    alias: '',
    allowedClientCIDRs: ['0.0.0.0/0'],
    allowedClientIPs: [''],
    billingTotalTokens: undefined,
    inputTokens: undefined,
    outputTokens: undefined,
    requests: undefined,
    inputTokensWindowSeconds: undefined,
    inputTokensValue: undefined,
    outputTokensWindowSeconds: undefined,
    outputTokensValue: undefined,
    strategyName: undefined,
    strategyDisplayName: '',
    strategyProvider: '',
    workspace: undefined,
    description: '',
  };
}

/** 创建态默认资源限制开关。 */
export function createDefaultModelSubscriptionSwitches(): ModelSubscriptionResourceSwitches {
  return {
    showTokenLimit: false,
    showRequests: false,
    showInputTokens: false,
    showOutputTokens: false,
  };
}

/** 将编辑态详情转换成表单可直接消费的数据。 */
export function normalizeDetailToFormValues(detail: ModelSubscriptionDetail): ModelSubscriptionNormalizedFormState {
  /** 订阅规格对象。 */
  const spec = detail?.spec || {};
  /** Token 总量限制。 */
  const billingTotalTokens = spec?.resourceLimits?.billingTotalTokens;
  /** 输入 Token 限制。 */
  const inputTokens = spec?.resourceLimits?.inputTokens;
  /** 输出 Token 限制。 */
  const outputTokens = spec?.resourceLimits?.outputTokens;
  /** 请求数限制。 */
  const requests = spec?.resourceLimits?.requests;
  /** 输入 Token 限速。 */
  const inputTokenRateLimit = spec?.rateLimits?.inputTokens;
  /** 输出 Token 限速。 */
  const outputTokenRateLimit = spec?.rateLimits?.outputTokens;
  /** 编辑态展示的模型供应商 ID。 */
  const strategyDisplayName = detail?.status?.customModelID || spec?.strategyName || '';

  const resolvedValues = {
    alias: spec.alias || '',
    allowedClientCIDRs: Array.isArray(spec.allowedClientCIDRs) && spec.allowedClientCIDRs.length ? spec.allowedClientCIDRs : ['0.0.0.0/0'],
    allowedClientIPs: Array.isArray(spec.allowedClientIPs) && spec.allowedClientIPs.length ? spec.allowedClientIPs : [''],
    workspace: spec.workspace,
    description: spec.description || '',
    strategyName: spec.strategyName,
    billingTotalTokens: billingTotalTokens?.enabled ? billingTotalTokens.value || undefined : undefined,
    inputTokens: inputTokens?.enabled ? inputTokens.value || undefined : undefined,
    outputTokens: outputTokens?.enabled ? outputTokens.value || undefined : undefined,
    requests: requests?.value || undefined,
    inputTokensWindowSeconds: inputTokenRateLimit?.windowSeconds || undefined,
    inputTokensValue: inputTokenRateLimit?.value || undefined,
    outputTokensWindowSeconds: outputTokenRateLimit?.windowSeconds || undefined,
    outputTokensValue: outputTokenRateLimit?.value || undefined,
    strategyDisplayName,
  };

  return {
    values: resolvedValues,
    switches: {
      showTokenLimit: false,
      showRequests: Boolean(requests?.enabled),
      showInputTokens: Boolean(inputTokenRateLimit?.enabled),
      showOutputTokens: Boolean(outputTokenRateLimit?.enabled),
    },
  };
}
